"use client";
import type { RowData } from "@tanstack/react-table";

import { EditColumnsSheet } from "./columns/edit-columns-sheet";
import type { RecordTableDialogsState } from "./use-record-table-dialogs";
import type { RecordTableModel } from "./use-record-table-model";
import { SaveCurrentViewDialog } from "./views/save-current-view-dialog";
import type { RecordTableProps } from "./types";

export function RecordTableDialogs<TData extends RowData>({
  props: { object, state },
  model,
  dialogs,
}: {
  props: RecordTableProps<TData>;
  model: RecordTableModel<TData>;
  dialogs: RecordTableDialogsState;
}) {
  return (
    <>
      {object.capabilities.columnEditing ? (
        <EditColumnsSheet
          object={object}
          open={dialogs.columnsOpen}
          onOpenChange={dialogs.setColumnsOpen}
          columns={state.columns}
          onApply={state.setColumns}
          onReset={state.resetColumns}
        />
      ) : null}
      {model.canPersistViews ? (
        <SaveCurrentViewDialog
          open={dialogs.saveOpen}
          onOpenChange={dialogs.setSaveOpen}
          draft={dialogs.saveDraft}
          state={state}
          actions={model.actions}
        />
      ) : null}
    </>
  );
}
